export const APP_NAV = [
  { path: "/app", label: "Início" },
  { path: "/app/practice", label: "Praticar" },
  { path: "/app/progress", label: "Progresso" },
] as const;

export const APP_SIDEBAR_EXTRA = {
  path: "/app/upgrade",
  labelPaid: "Assinatura",
  labelFree: "Assinar",
} as const;
